import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'

import AppConstants from '../../utils/AppConstants'
import AppUtils from '../../utils/AppUtils'
import Form from '../elements/Form'
import TextInput from '../elements/forms/TextInput'
import IntegerInput from '../elements/forms/IntegerInput'
import GenericSelect from '../elements/forms/GenericSelect'
import CheckboxInput from '../elements/forms/CheckboxInput'
import StaticInput from '../elements/forms/StaticInput'
import Sticker from '../elements/Sticker'
import Dismissible from '../elements/Dismissible'

const ERROR = {
  EMPTY_NAME: 'Le nom ne peut pas être vide.',
  EMPTY_OWNER: 'Veuillez choisir un groupe matériel.',
  EMPTY_PREFIX: 'Le préfixe ne peut pas être vide.',
  EMPTY_PIPE_LENGTH: 'La longueur de tuyau ne peut pas être vide.',
  EMPTY_PIPE_DIAMETER: 'Veuillez choisir un diamètre de tuyau.',
  EMPTY_BATTERY_COUNT: 'Le nombre de batteries ne peut pas être vide.',
  EMPTY_BATTERY_TYPE: 'Veuillez choisir un type de batteries.'
}

class ProductForm extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      input: this.getInitialInput(props),
      formErrors: []
    }

    // Bind events
    this.onChangeInputName = this.onChangeInputName.bind(this)
    this.onChangeInputCategory = this.onChangeInputCategory.bind(this)
    this.onChangeInputPrice = this.onChangeInputPrice.bind(this)
    this.onChangeInputProvider = this.onChangeInputProvider.bind(this)
    this.onChangeInputReparator = this.onChangeInputReparator.bind(this)
    this.onChangeInputOwner = this.onChangeInputOwner.bind(this)
    this.onChangeInputPrefix = this.onChangeInputPrefix.bind(this)
    this.onChangeCheckboxPrefix = this.onChangeCheckboxPrefix.bind(this)
    this.onChangeInputRemark = this.onChangeInputRemark.bind(this)
    this.onChangeCheckboxTocheck = this.onChangeCheckboxTocheck.bind(this)
    this.onChangeInputType = this.onChangeInputType.bind(this)
    this.onChangeInputPipeLength = this.onChangeInputPipeLength.bind(this)
    this.onChangeInputPipeDiameter = this.onChangeInputPipeDiameter.bind(this)
    this.onChangeInputPipeSeparate = this.onChangeInputPipeSeparate.bind(this)
    this.onChangeInputBatteriesCount = this.onChangeInputBatteriesCount.bind(this)
    this.onChangeInputBatteriesType = this.onChangeInputBatteriesType.bind(this)
    this.onSubmit = this.onSubmit.bind(this)

    // Register submit event
    if (_.isFunction(this.props.registerSubmit)) {
      this.props.registerSubmit(this.onSubmit)
    }
  }

  getInitialInput(props = this.props) {
    return _.extend(
      {
        name: (props && props.data && props.data.name) || '',
        owner: (props && props.data && props.data.owner && props.data.owner.id) || null
      },
      (props && props.isFull)
        ? {
            price: (props && props.data && props.data.price) || '',
            provider: (props && props.data && props.data.provider) || '',
            reparator: (props && props.data && props.data.reparator) || '',
            prefix: (props && props.data)
              ? props.data.prefix
              : '',
            remark: (props && props.data && props.data.remark) || '',
            tocheck: (props && props.data && props.data.tocheck) || false,
            specialization: (props && props.data && props.data.specialization)
              ? _.extend(
                  {
                    type: props.data.specialization.type
                  },
                  props.data.specialization.type === AppConstants.PRODUCT.TYPE.PIPE
                    ? _.extend(
                        _.pick(props.data.specialization, 'pipe_length'),
                        {
                          pipe_diameter: props.data.specialization.pipe_diameter.id,
                          pipe_separate: props.data.specialization.pipe_separate ? 'true' : 'false'
                        }
                      )
                    : {},
                  props.data.specialization.type === AppConstants.PRODUCT.TYPE.BATTERY
                    ? _.extend(
                        _.pick(props.data.specialization, 'batteries_count'),
                        {
                          batteries_type: props.data.specialization.batteries_type.id
                        }
                      )
                    : {}
                )
              : {
                  type: AppConstants.PRODUCT.TYPE.NONE
                }
          }
        : {},
      (props && !props.isFull)
        ? {
            category: (props.category && props.category.id) || null
          }
        : {}
    )
  }

  setInput(input = {}) {
    this.setState((prevState, props) => ({
      input: _.extend(
        {},
        prevState.input,
        input
      )
    }))
  }

  setSpecialization(specialization = {}) {
    this.setState((prevState, props) => ({
      input: _.extend(
        {},
        prevState.input,
        {
          specialization: _.extend(
            {},
            prevState.input.specialization,
            specialization
          )
        }
      )
    }))
  }

  componentDidUpdate(prevProps, prevState) {
    // When async fetch finished
    if (prevProps.isLoading && !this.props.isLoading) {
      this.setState({
        input: this.getInitialInput()
      })
    }
  }

  onChangeInputName(name) {
    this.setInput({ name })
  }

  onChangeInputCategory(category) {
    this.setInput({ category })
  }

  onChangeInputPrice(price) {
    this.setInput({ price })
  }

  onChangeInputProvider(provider) {
    this.setInput({ provider })
  }

  onChangeInputReparator(reparator) {
    this.setInput({ reparator })
  }

  onChangeInputOwner(owner) {
    this.setInput({ owner })
  }

  onChangeInputPrefix(prefix) {
    this.setInput({ prefix })
  }

  onChangeCheckboxPrefix(checked) {
    this.setInput({
      prefix: checked ? null : ''
    })
  }

  onChangeInputRemark(remark) {
    this.setInput({ remark })
  }

  onChangeCheckboxTocheck(tocheck) {
    this.setInput({ tocheck })
  }

  onChangeInputType(type) {
    this.setInput({
      specialization: _.extend(
        { type },
        type === AppConstants.PRODUCT.TYPE.PIPE
          ? {
              pipe_length: '',
              pipe_diameter: null,
              pipe_separate: true
            }
          : {},
        type === AppConstants.PRODUCT.TYPE.BATTERY
          ? {
              batteries_count: '',
              batteries_type: null
            }
          : {}
      )
    })
  }

  onChangeInputPipeLength(pipe_length) {
    this.setSpecialization({ pipe_length })
  }

  onChangeInputPipeDiameter(pipe_diameter) {
    this.setSpecialization({ pipe_diameter })
  }

  onChangeInputPipeSeparate(pipe_separate) {
    this.setSpecialization({ pipe_separate })
  }

  onChangeInputBatteriesCount(batteries_count) {
    this.setSpecialization({ batteries_count })
  }

  onChangeInputBatteriesType(batteries_type) {
    this.setSpecialization({ batteries_type })
  }

  onSubmit() {
    // Check that fields have been filled
    const formErrors = []
    if (!_.isString(this.state.input.name) || this.state.input.name.length === 0) {
      formErrors.push(ERROR.EMPTY_NAME)
    }
    if (_.isNull(this.state.input.owner)) {
      formErrors.push(ERROR.EMPTY_OWNER)
    }
    if (this.props.isFull) {
      if (!_.isNull(this.state.input.prefix) && this.state.input.prefix.length === 0) {
        formErrors.push(ERROR.EMPTY_PREFIX)
      }
      if (this.state.input.specialization.type === AppConstants.PRODUCT.TYPE.PIPE) {
        if (!_.isNumber(this.state.input.specialization.pipe_length) || String(this.state.input.specialization.pipe_length).length === 0) {
          formErrors.push(ERROR.EMPTY_PIPE_LENGTH)
        }
        if (_.isNull(this.state.input.specialization.pipe_diameter)) {
          formErrors.push(ERROR.EMPTY_PIPE_DIAMETER)
        }
      }
      if (this.state.input.specialization.type === AppConstants.PRODUCT.TYPE.BATTERY) {
        if (!_.isNumber(this.state.input.specialization.batteries_count) || String(this.state.input.specialization.batteries_count).length === 0) {
          formErrors.push(ERROR.EMPTY_BATTERY_COUNT)
        }
        if (_.isNull(this.state.input.specialization.batteries_type)) {
          formErrors.push(ERROR.EMPTY_BATTERY_TYPE)
        }
      }
    }
    this.setState({
      formErrors
    })
    if (!_.isEmpty(formErrors)) {
      return;
    }

    // Build and submit correctly formatted input
    const input = _.extend(
      _.pick(this.state.input, 'name'),
      {
        owner: {
          id: this.state.input.owner
        }
      },
      this.props.isFull
        ? _.extend(
            _.pick(this.state.input, 'price', 'provider', 'reparator', 'prefix', 'remark', 'tocheck'),
            {
              specialization: _.extend(
                _.pick(this.state.input.specialization, 'type'),
                this.state.input.specialization.type === AppConstants.PRODUCT.TYPE.PIPE
                  ? _.extend(
                      _.pick(this.state.input.specialization, 'pipe_length'),
                      {
                        pipe_diameter: {
                          id: this.state.input.specialization.pipe_diameter
                        },
                        pipe_separate: this.state.input.specialization.pipe_separate === 'true'
                      }
                    )
                  : {},
                this.state.input.specialization.type === AppConstants.PRODUCT.TYPE.BATTERY
                  ? _.extend(
                      _.pick(this.state.input.specialization, 'batteries_count'),
                      {
                        batteries_type: {
                          id: this.state.input.specialization.batteries_type
                        }
                      }
                    )
                  : {}
              )
            }
          )
        : (
            (!this.props.data || this.state.input.category !== this.props.category.id)
              ? {
                  category: {
                    id: this.state.input.category
                  }
                }
              : {}
          )
    )
    this.props.onSubmit(input)
  }

  render() {
    return (
      <React.Fragment>
        {
          this.props.error
            ? <Dismissible
                header={AppUtils.errorToTitle(this.props.error)}
                content={AppUtils.errorToText(this.props.error, {
                  [AppConstants.ERROR.BAD_REQUEST.UNICITY_CONSTRAINT_VIOLATION]: 'Un matériel avec ce nom existe déjà.'
                })}
                color='red'
                onDismiss={this.props.onClearError}
              />
            : null
        }
        {
          !_.isEmpty(this.state.formErrors)
            ? <Dismissible
                content='Veuillez résoudre les problèmes ci-dessous avant de poursuivre.'
                color='orange'
              />
            : null
        }
        <Form
          onSubmit={this.onSubmit}
          loading={this.props.isLoading || this.props.isSaving}
        >
          {
            this.props.data && !this.props.isFull
              ? <GenericSelect
                label='Catégorie'
                loading={this.props.categoriesIsFetching}
                options={
                  _.map(this.props.categoriesList, (category) => ({
                    key: category.id,
                    value: (
                      <span>
                        <Sticker
                          foreground={category.color.foreground}
                          background={category.color.background}
                          text={category.name}
                        />
                      </span>
                    ),
                    searchValue: category.name
                  }))
                }
                selected={this.state.input.category}
                onChange={this.onChangeInputCategory}
                canSearch={true}
                reducedPadding={true}
              />
              : <StaticInput
                  label='Catégorie'
                  content={
                    <Sticker
                      foreground={this.props.category.color.foreground}
                      background={this.props.category.color.background}
                      text={this.props.category.name}
                    />
                  }
                />
          }
          <TextInput
            label='Nom'
            placeholder='Tuyau'
            value={this.state.input.name}
            onChange={this.onChangeInputName}
            error={
              _.contains(this.state.formErrors, ERROR.EMPTY_NAME)
                ? ERROR.EMPTY_NAME
                : null
            }
          />
          <GenericSelect
            label='Groupe matériel'
            loading={this.props.ownersIsFetching}
            options={
              _.isArray(this.props.ownersList)
                ? _.map(this.props.ownersList, (owner) => ({
                    key: owner.id,
                    value: owner.name
                  }))
                : []
            }
            selected={this.state.input.owner}
            onChange={this.onChangeInputOwner}
            error={
              _.contains(this.state.formErrors, ERROR.EMPTY_OWNER)
                ? ERROR.EMPTY_OWNER
                : null
            }
          />
          {
            this.props.isFull
              ? <React.Fragment>
                  <TextInput
                    label='Prix'
                    placeholder='10.-'
                    value={this.state.input.price}
                    onChange={this.onChangeInputPrice}
                  />
                  <TextInput
                    label='Fournisseur'
                    placeholder='Growag'
                    value={this.state.input.provider}
                    onChange={this.onChangeInputProvider}
                  />
                  <TextInput
                    label='Réparateur'
                    placeholder='SAMI'
                    value={this.state.input.reparator}
                    onChange={this.onChangeInputReparator}
                  />
                  <TextInput
                    label='Préfixe'
                    placeholder={
                      _.isNull(this.state.input.prefix)
                        ? ''
                        : 'SISBAEXT'
                    }
                    value={
                      _.isNull(this.state.input.prefix)
                        ? ''
                        : this.state.input.prefix
                    }
                    onChange={
                      _.isNull(this.state.input.prefix)
                        ? undefined
                        : this.onChangeInputPrefix
                    }
                    error={
                      _.contains(this.state.formErrors, ERROR.EMPTY_PREFIX)
                        ? ERROR.EMPTY_PREFIX
                        : null
                    }
                    disabled={_.isNull(this.state.input.prefix)}
                  />
                  <CheckboxInput
                    label=''
                    text='Sans numéro individuel'
                    checked={_.isNull(this.state.input.prefix)}
                    onChange={this.onChangeCheckboxPrefix}
                    smallPadding={true}
                  />
                  <TextInput
                    label='Remarque'
                    placeholder='...'
                    value={this.state.input.remark}
                    onChange={this.onChangeInputRemark}
                    multiline={true}
                  />
                  <CheckboxInput
                    label='Status'
                    text='A mettre en ordre'
                    checked={this.state.input.tocheck}
                    onChange={this.onChangeCheckboxTocheck}
                  />
                  <GenericSelect
                    label='Type'
                    options={[
                      { key: AppConstants.PRODUCT.TYPE.NONE, value: 'Standard' },
                      { key: AppConstants.PRODUCT.TYPE.PIPE, value: 'Tuyau' },
                      { key: AppConstants.PRODUCT.TYPE.BATTERY, value: 'Appareil à batteries' }
                    ]}
                    selected={this.state.input.specialization.type}
                    onChange={this.onChangeInputType}
                  />
                  {
                    this.state.input.specialization.type === AppConstants.PRODUCT.TYPE.PIPE
                      ? <React.Fragment>
                          <IntegerInput
                            label='Longueur (m)'
                            placeholder='20'
                            value={this.state.input.specialization.pipe_length}
                            onChange={this.onChangeInputPipeLength}
                            error={
                              _.contains(this.state.formErrors, ERROR.EMPTY_PIPE_LENGTH)
                                ? ERROR.EMPTY_PIPE_LENGTH
                                : null
                            }
                          />
                          <GenericSelect
                            label='Diamètre'
                            loading={this.props.diametersIsFetching}
                            options={
                              _.isArray(this.props.diametersList)
                                ? _.map(this.props.diametersList, (diameter) => ({
                                    key: diameter.id,
                                    value: `${diameter.diameter} mm`
                                  }))
                                : []
                            }
                            selected={this.state.input.specialization.pipe_diameter}
                            onChange={this.onChangeInputPipeDiameter}
                            error={
                              _.contains(this.state.formErrors, ERROR.EMPTY_PIPE_DIAMETER)
                                ? ERROR.EMPTY_PIPE_DIAMETER
                                : null
                            }
                          />
                          <GenericSelect
                            label='Roulé'
                            options={[
                              { key: 'true', value: 'Séparément' },
                              { key: 'false', value: 'Dévidoir' }
                            ]}
                            selected={this.state.input.specialization.pipe_separate}
                            onChange={this.onChangeInputPipeSeparate}
                          />
                        </React.Fragment>
                      : null
                  }
                  {
                    this.state.input.specialization.type === AppConstants.PRODUCT.TYPE.BATTERY
                      ? <React.Fragment>
                          <IntegerInput
                            label='Batteries'
                            placeholder='1'
                            value={this.state.input.specialization.batteries_count}
                            onChange={this.onChangeInputBatteriesCount}
                            error={
                              _.contains(this.state.formErrors, ERROR.EMPTY_BATTERY_COUNT)
                                ? ERROR.EMPTY_BATTERY_COUNT
                                : null
                            }
                          />
                          <GenericSelect
                            label='Modèle'
                            loading={this.props.batteriesIsFetching}
                            options={
                              _.isArray(this.props.batteriesList)
                                ? _.map(this.props.batteriesList, (battery) => ({
                                    key: battery.id,
                                    value: battery.name
                                  }))
                                : []
                            }
                            selected={this.state.input.specialization.batteries_type}
                            onChange={this.onChangeInputBatteriesType}
                            error={
                              _.contains(this.state.formErrors, ERROR.EMPTY_BATTERY_TYPE)
                                ? ERROR.EMPTY_BATTERY_TYPE
                                : null
                            }
                          />
                        </React.Fragment>
                      : null
                  }
                </React.Fragment>
              : null
          }
        </Form>
      </React.Fragment>
    )
  }
}

ProductForm.propTypes = {
  // Display the full or minimal form
  isFull: PropTypes.bool.isRequired,
  // Category to which the product is linked { id, name, color: { foreground, background } }
  category: PropTypes.object,
  data: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onClearError: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  registerSubmit: PropTypes.func,
  error: PropTypes.object,
  categoriesList: PropTypes.array,
  categoriesIsFetching: PropTypes.bool,
  ownersList: PropTypes.array,
  ownersIsFetching: PropTypes.bool,
  diametersList: PropTypes.array,
  diametersIsFetching: PropTypes.bool,
  batteriesList: PropTypes.array,
  batteriesIsFetching: PropTypes.bool
}

export default ProductForm



// WEBPACK FOOTER //
// ./src/components/forms/ProductForm.js